import { GET_JOURNALISTS } from '../constants/journalists';
import { fetchJournalists } from '../api/journalists';

export const getJournalists = () => async (dispatch) => {
  const journalists = await fetchJournalists();
  dispatch({
    type: GET_JOURNALISTS,
    payload: journalists
  });
};
